module.exports = __webpack_public_path__ + "a05141f4e7074c9d369765142c45d117.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg82.jpeg
// module id = 97
// module chunks = 0